import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      gap: "32px",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        gap: "24px",
      },
    },
    wrapperTabsRoot: {
      maxWidth: "200px !important",
      padding: "0px !important",

      '& .MuiTabs-scroller': {
        background: "transparent !important",
        width: "100% !important",

        "& .MuiTabs-flexContainer": {
          border: "none !important",
        },

        "& .MuiButtonBase-root": {
          marginBottom: "4px !important",
          fontSize: "16px !important",
          fontWeight: "600 !important",
          lineHeight: "24px !important",
          padding: "10px 14px !important",
          width: "100% !important",
          color: `${theme.palette?.text?.text_quarterary} !important`,

          "& span": {
            alignItems: "flex-start !important",
          },

          "&.Mui-selected": {
            border: "none !important",
            background: "transparent !important",
            borderInlineStart: `2px solid ${theme.palette?.foreground?.brandPrimary} !important`,
            borderRadius: "0px !important",
            color: `${theme.palette?.text?.brand_secondary} !important`,
          }
        },
      }
    },
    tabsContentWrapper: {
      width: "100%",
      border: "none !important",
    },
    formActionsWrapper: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "12px",
      marginBottom: "24px",
    },
    currentTabTitle: {
      fontSize: "18px",
      fontWeight: 600,
      lineHeight: "28px",
      color: theme.palette.text?.primary,
    },
    actionsWrapper: {
      gap: "12px",
    },
    activeTabContentWrapper: {
      background: `${theme.palette?.background?.primary} !important`,
      padding: "24px 32px !important",
      border: `1px solid ${theme.palette?.border?.secondary} !important`,
      borderRadius: "12px !important",
      "& .form-item": {
        marginBottom: "20px !important",
        paddingBottom: "20px !important",
        borderBottom: `1px solid ${theme.palette?.border?.secondary} !important`,
        '&:last-child': {
          borderBottom: 'none !important',
          marginBottom: "0px !important",
          paddingBottom: "0px !important",
        },
      },
    },
  }
});
